export const environment = {
  production: false,
  localesList: [
    { code: 'en', label: 'EN' },
    { code: 'fr', label: 'FR' },
    { code: 'es', label: 'ES' },
  ],
  syncfusion_license_key: 'ORg4AjUWIQA/Gnt2VFhiQlJPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXhTcEVhWn9edXdTR2g=',
};
